<template>
    <el-dialog
        :before-close="close"
        :title="title"
        :visible.sync="dialog.visible"
        width="400px"
    >
        <p style="font-size: 16px; margin-bottom: 20px">
            是否确定分配给 {{ agentName }} 商户？
        </p>
        <el-form :model="form" label-width="120px">
            <el-form-item label="通道数">
                <el-select style="width: 100%" v-model="form.channel">
                    <el-option
                        :key="item"
                        :label="form.noFusionChannel === 0 ? item - 1 : item"
                        :value="form.noFusionChannel === 0 ? item - 1 : item"
                        v-for="item in channels"
                    />
                </el-select>
            </el-form-item>
            <el-form-item label="触控通道数">
                <el-select style="width: 100%" v-model="form.touch">
                    <el-option
                        :key="item"
                        :label="item - 1"
                        :value="item - 1"
                        v-for="item in maxChannel + 1"
                    />
                </el-select>
            </el-form-item>
            <el-form-item label="授权">
                <el-select style="width: 100%" v-model="form.auth">
                    <el-option
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                        v-for="item in AUTH_ARRAY"
                    />
                </el-select>
            </el-form-item>
            <el-form-item label="结束时间" v-if="form.auth === AUTH_PROBATION">
                <el-date-picker
                    format="yyyy-MM-dd 00:00:00"
                    placeholder="选择日期"
                    style="width: 100%"
                    type="date"
                    v-model="form.expireTime"
                    value-format="yyyy-MM-dd 00:00:00"
                />
            </el-form-item>
            <!-- <el-form-item label="备注">
				<el-input type="textarea" placeholder="请输入内容" maxlength="200" :rows="5" v-model="form.comment" />
            </el-form-item>-->
            <el-form-item label="场景">
                <el-select style="width: 100%" v-model="form.scene">
                    <el-option label="KTV" :value="1" />
                    <el-option label="专业" :value="2" />
                    <el-option label="预留1" :value="3" />
                    <el-option label="预留2" :value="4" />
                </el-select>
            </el-form-item>
            <el-form-item label="支持融合">
                <el-switch
                    v-model="form.noFusionChannel"
                    :active-value="0"
                    :inactive-value="1"
                />
            </el-form-item>
            <el-form-item label="互动游戏">
                <el-switch
                    v-model="form.appControl"
                    :active-value="1"
                    :inactive-value="0"
                />
            </el-form-item>
            <el-form-item label="控制字符">
                <el-input
                    placeholder="请输入内容"
                    maxlength="120"
                    v-model="form.memo"
                />
            </el-form-item>
            <el-form-item label="关注公众号">
                <el-switch
                    v-model="form.isH5QrCode"
                    :active-value="0"
                    :inactive-value="1"
                />
            </el-form-item>
            <el-form-item label="二维码">
                <el-switch
                    v-model="form.qrEnable"
                    :active-value="1"
                    :inactive-value="0"
                />
            </el-form-item>
        </el-form>
        <span slot="footer">
            <el-button @click="close">取消</el-button>
            <el-button @click="handle" type="primary">确定</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import {
    DEVICE_DIALOG,
    DEVICE_BIND,
    AUTH_ARRAY,
    AUTH_PROBATION,
} from '../../../libs/enum.js';

const { mapState, mapActions } = createNamespacedHelpers('agentDevice');

export default {
    data() {
        return {
            AUTH_ARRAY,
            AUTH_PROBATION,
        };
    },
    computed: {
        ...mapState({
            dialog: (state) => state.dialog,
            form: (state) => state.form,
            maxChannel: (state) => state.maxChannel,
        }),
        title() {
            return DEVICE_DIALOG[this.dialog.type];
        },
        agentId() {
            return this.$route.query.agentId;
        },
        agentName() {
            return this.$route.query.agentName;
        },
        channels() {
            return this.form.noFusionChannel === 0
                ? this.maxChannel + 1
                : this.maxChannel;
        },
    },
    watch: {
        'form.noFusionChannel': function (val) {
            if (val === 1 && this.form.channel === 0) {
                this.form.channel = 1;
            }
        },
    },
    methods: {
        ...mapActions(['changeDialog', 'bindDevice', 'authDevice']),
        close() {
            this.changeDialog({ visible: false, type: DEVICE_BIND });
        },
        handle() {
            this.dialog.type === DEVICE_BIND
                ? this.bindDevice(this.agentId)
                : this.authDevice();
        },
    },
};
</script>
